/**
 * DatePicker Component
 * Encapsulated date input field with consistent styling
 */

import React from 'react';
import { useTheme } from '@mui/material/styles';
import { TextField } from './TextField';
import { TextFieldProps } from '@mui/material';

export interface DatePickerProps extends Omit<TextFieldProps, 'type'> {
  // Inherits all TextField props but type is always 'date'
}

export const DatePicker: React.FC<DatePickerProps> = ({
  sx,
  ...props
}) => {
  const theme = useTheme();
  return (
    <TextField
      type="date"
      size="small"
      InputLabelProps={{ shrink: true }}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        // Find the native input and call showPicker()
        const input = (e.currentTarget.querySelector('input') as any);
        if (input && input.showPicker) {
          input.showPicker();
        }
      }}
      sx={{
        '& .MuiInputBase-input::-webkit-calendar-picker-indicator': {
          cursor: 'pointer',
          filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
          opacity: 0.6,
          '&:hover': {
            opacity: 1,
          },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

